import BMF from '@/utils/sparkMd5'
import request from '@/utils/request'
import { uuid } from 'vue-uuid'
import store from '../store/index.js'
import { resizeImage, base64ToBlob, blobToFile } from './transitionFile.js'

function uploadSmallImg (file, hash, awsSdk, w, h) {
  let url = ''
  // 获取file对象URL
  if (navigator.userAgent.indexOf('Firefox') > 0) { // Firefox
    url = window.URL.createObjectURL(file)
  } else if (navigator.userAgent.indexOf('Chrome') > 0) { // Chrome
    url = window.URL.createObjectURL(file)
  }
  resizeImage(url, (val) => {
    awsSdk.upload(blobToFile(base64ToBlob(val), file.name), store.state.user.userId + '/' + hash + 'w_' + w + 'h_' + h + file.name.slice(file.name.lastIndexOf('.'))).then(res => {
    })
  }, w, h)
}
const bmf = new BMF()
export default function uploadWebImg (file, awsSdk, tags, cd, w, h) {
  return new Promise(function (resolve, reject) {
    bmf.md5(file, (val, hash) => {
      awsSdk.upload(file, store.state.user.userId + '/' + hash + file.name.slice(file.name.lastIndexOf('.')), tags, cd).then(res => {
        // awsSdk.upload(file, store.state.user.userId + '/' + file.name.slice(0, file.name.lastIndexOf('.')) + '-' + hash + file.name.slice(file.name.lastIndexOf('.')), tags, cd).then(res => {
        if (res === 'error') {
          resolve('error')
        } else {
          let url = res.Location
          if (process.env.NODE_ENV === 'production') {
            url = url.replace('http://', 'https://')
          }
          resolve(url)
        }
      })
      if (w && h) {
        // 上传缩略图
        uploadSmallImg(file, hash, awsSdk, w, h)
      }
    })
  })
}
export function uploadStr (str, awsSdk) {
  return new Promise(function (resolve, reject) {
    awsSdk.upload(str, store.state.user.userId + '/' + uuid.v1().replace(/-/g, '') + '.json').then(res => {
      resolve(res.Location)
    })
  })
}
export function getAwsSdk (bucketType) {
  return new Promise(function (resolve, reject) {
    request({
      url: `/api/pub/oss/sdsXsky/sts/sessionToken/${bucketType}`,
      method: 'get'
    }).then(res => {
      if (res.data.success) {
        let sdsXskyToken = res.data.data
        // resolve(new AwsSdk(sdsXskyToken.accessKeyId, sdsXskyToken.secretAccessKey, sdsXskyToken.bucketName, sdsXskyToken.endpoint, sdsXskyToken.sessionToken))
        resolve(res.data.data)
      }
    })
  })
}
function checkTimeOut (date) {
  let timeout = new Date(date.replace(/-/g, '/')).getTime()
  let now = new Date().getTime()
  return timeout - now <= 1000 * 60 * 5
}
export function checkAwsSdk (bucketType) {
  return store.state.awsSdk[bucketType].sessionToken === null ||
    checkTimeOut(store.state.awsSdk[bucketType].sessionToken.expiration) ||
    store.state.awsSdk[bucketType].s3 === null
}
